import styled from 'styled-components'

/**
 * 기본 조립, 프리미엄 기본 조립 서비스 신청 팝업의 스타일과 아이콘 정리
 * @type {StyledComponent<"div", AnyIfEmpty<DefaultTheme>, {}, never>}
 */

export const WrapColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 15px;
`

export const WrapRow = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-top: 8px;
`
export const WrapIcon = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    border: 1px solid #999999;
    border-radius: 25px;
`
export const WrapText = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    margin-left: 10px;
`
export const WrapSpan = styled.span`
    font-size: 14px;
    line-height: 19px;
    color: #666666;
    strong {
        color: #418ded;
    }
`

export const IconBasic = styled.i`
    display: flex;
    width: 50px;
    height: 50px;
    align-items: center;
    justify-content: center;
    font-size: 50px;
    font-style: normal;
    color: #999999;

    &:before {
        font-family: 'icomoon';
        content: '\\e902';
    }
`

export const IconBasic1 = styled.i`
    display: flex;
    width: 50px;
    height: 50px;
    align-items: center;
    justify-content: center;
    font-size: 50px;
    font-style: normal;
    color: #999999;

    &:before {
        font-family: 'icomoon';
        content: '\\e90c';
    }
`
export const IconBasic2 = styled.i`
    display: flex;
    width: 50px;
    height: 50px;
    align-items: center;
    justify-content: center;
    font-size: 50px;
    font-style: normal;
    color: #999999;

    &:before {
        font-family: 'icomoon';
        content: '\\e909';
    }
`
export const IconPremium = styled.i`
    display: flex;
    width: 50px;
    height: 50px;
    align-items: center;
    justify-content: center;
    font-size: 50px;
    font-style: normal;
    color: #999999;

    &:before {
        font-family: 'icomoon';
        content: '\\e90f';
    }
`
export const IconPremium1 = styled.i`
    display: flex;
    width: 50px;
    height: 50px;
    align-items: center;
    justify-content: center;
    font-size: 50px;
    font-style: normal;
    color: #999999;

    &:before {
        font-family: 'icomoon';
        content: '\\e906';
    }
`

export const IconPremium2 = styled.i`
    display: flex;
    width: 50px;
    height: 50px;
    align-items: center;
    justify-content: center;
    font-size: 35px;
    font-style: normal;
    color: #999999;

    &:before {
        font-family: 'icomoon';
        content: '\\e903';
    }
`

export const IconBox = styled.i`
    display: flex;
    width: 50px;
    height: 50px;
    align-items: center;
    justify-content: center;
    font-size: 50px;
    font-style: normal;
    color: #666666;

    &:before {
        font-family: 'icomoon';
        content: '\\e912';
    }
`

export const PcInstallService1 = styled.i`
    display: flex;
    width: 50px;
    height: 50px;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    font-style: normal;
    color: #999999;

    &:before {
        font-family: 'pping_v4_service';
        content: '\\e900';
    }
`

export const PcInstallService2 = styled.i`
    display: flex;
    width: 50px;
    height: 50px;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    font-style: normal;
    color: #999999;

    &:before {
        font-family: 'pping_v4_service';
        content: '\\e901';
    }
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/estimate/icomoon.js